import { render, staticRenderFns } from "./ListInvites.vue?vue&type=template&id=8f0ecb72&"
import script from "./ListInvites.vue?vue&type=script&lang=js&"
export * from "./ListInvites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports